export default __webpack_public_path__ + "static/eneAcademyTimeline-906630e713f96313f2b963728ac5d452.png";